import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import AppointmentMain from '../pages/appointment/AppointmentMain';
import Navbar from '../components/Navbar';

const Stack = createStackNavigator();

export default function AppointmentRoute() {
  return (
    <Stack.Navigator 
      initialRouteName="AppointmentMain"
      screenOptions={{
        header: ({ navigation }) => (
          <Navbar navigation={navigation} />
        ),
      }}
    >
      <Stack.Screen name="AppointmentMain" component={AppointmentMain} />
    </Stack.Navigator>
  );
};